import React from 'react';
import {getBillingUrl, goLogin} from "../../../../common/utils/passUtil";

export default function PointBox (props) {
    return (
        <>
            {
                props.data && props.data.map((item, index) => {
                    const billingUrl = getBillingUrl(props.loginJwt,'pc', 'point', item.product_id)
                    const option = 'width=570,height=603,resizable=yes,scrollbars=yes'
                    const target = 'Billing'

                    return (
                        <div key={`point-box-${index}`} className={`pointModule_type${props.type}`}>
                            {item.label && (<span className={`moduleLabel-${item.label.type}`}>{item.label.text}</span>)}
                            <a href="#" className="pointModuleLink" onClick={() => props.loginJwt ?  window.open(billingUrl, target, option) : window.location.href=goLogin()}>
                                <div className="pointModuleSubTitle">{item.product_name}</div>
                                <div className="pointModuleCont">
                                    <strong className="pointModuleTitle">{item.display_price}</strong>
                                    <em className="pointModuleNumber">{item.price}</em>
                                </div>
                                <strong className="pointModule_noticeTitle">유의사항</strong>
			                    <ul className="pointModule_noticeList">
				                    <li className="pointModule_noticeText">사용 기간은 구매 후&nbsp;1년입니다.</li>
				                    <li className="pointModule_noticeText">구매 후 이용권 구매 클릭 시&nbsp;쿠폰 리스트에&nbsp;등록됩니다.</li>
				                    <li className="pointModule_noticeText">사용하신 포인트는 환불 불가합니다.</li>
			                    </ul>
                            </a>
                        </div>
                    )
                })
            }
        </>
    );
}
